import { render } from "./Notes.vue?vue&type=template&id=6aac6edf"
import script from "./Notes.vue?vue&type=script&lang=ts"
export * from "./Notes.vue?vue&type=script&lang=ts"

import "./Notes.vue?vue&type=style&index=0&id=6aac6edf&lang=scss"
script.render = render

export default script